import React from 'react';
import { Row, Col } from 'antd';
import CtaDistributionCard from './CtaDistributionCard.jsx';
import CtaWordCloudCard from './CtaWordCloudCard.jsx';
import CtaValidationStatusCard from './CtaValidationStatusCard.jsx';
import ModelConsumptionCard from './ModelConsumptionCard.jsx';
import UserActivityRateCard from './UserActivityRateCard.jsx';
import UserSubmissionContentCard from './UserSubmissionContentCard.jsx';

export default function AdditionalInsights({ dateParams, userActivityRate, userSubmissionContent }) {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={8}>
        <CtaDistributionCard dateParams={dateParams} />
      </Col>
      <Col xs={24} lg={8}>
        <CtaWordCloudCard dateParams={dateParams} />
      </Col>
      <Col xs={24} lg={8}>
        <CtaValidationStatusCard dateParams={dateParams} />
      </Col>

      <Col xs={24} lg={8}>
        <ModelConsumptionCard dateParams={dateParams} />
      </Col>
      <Col xs={24} lg={8}>
        <UserActivityRateCard data={userActivityRate} dateParams={dateParams} />
      </Col>
      <Col xs={24} lg={8}>
        <UserSubmissionContentCard data={userSubmissionContent} />
      </Col>
    </Row>
  );
}


